var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_vm._l((5),function(n){return [(n <= _vm.stars)?[_c('FullStarIcon',{key:n,staticClass:"star",attrs:{"data-cy":"full-star"}})]:[_c('EmptyStarIcon',{key:n,staticClass:"star",attrs:{"data-cy":"empty-star"}})]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }